export default "/_next/static/chunks/bust-1-d.a0e5f5de682320debd6f5cb6515ee1ed.glb";